import { render } from "./Message.vue?vue&type=template&id=22bf3db9&scoped=true"
import script from "./Message.vue?vue&type=script&lang=js"
export * from "./Message.vue?vue&type=script&lang=js"

import "@/styles/header.css?vue&type=style&index=0&id=22bf3db9&scoped=true&lang=css&external"
import "@/styles/common.css?vue&type=style&index=1&id=22bf3db9&scoped=true&lang=css&external"
import "@/styles/subcommon.css?vue&type=style&index=2&id=22bf3db9&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22bf3db9"]])

export default __exports__